import React from 'react';
import AdminContentPostsPage from './AdminContentPostsPage';

const AdminArticlesPage = () => <AdminContentPostsPage type="Article" title="Статьи" />;

export default AdminArticlesPage;
